import { useNavigate } from "react-router-dom";
import { Hourglass, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { FullLoader } from "../App";

export default function PendingPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user === null) return <FullLoader />;
  if (user === false) { navigate("/login"); return null; }
  if (user.status === "active" && user.tenant_id) { navigate("/"); return null; }

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-6" data-testid="pending-page">
      <div className="w-full max-w-md text-center space-y-6 bg-white border border-slate-200 rounded-2xl p-10 shadow-sm">
        <div className="mx-auto h-14 w-14 rounded-full bg-amber-100 flex items-center justify-center">
          <Hourglass className="h-7 w-7 text-amber-600" />
        </div>
        <div className="space-y-2">
          <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Account pending assignment</h2>
          <p className="text-sm text-slate-500 leading-relaxed">
            Hi {user.name || "there"} — your Google account (<span className="font-medium text-slate-700">{user.email}</span>) is registered
            but not yet assigned to a business workspace. A platform administrator will assign your tenant and role shortly.
          </p>
        </div>
        <Button variant="outline" onClick={doLogout} data-testid="pending-logout-btn">
          <LogOut className="h-4 w-4 mr-2" /> Sign out
        </Button>
      </div>
    </div>
  );
}
